import { Spinner } from '@heroui/react';

/**
 * The loading state of one CARD, where `PageLoader` is the loading state of a
 * whole route.
 *
 * ⚠️ IT REPLACES SIXTEEN COPIES OF `<p className="text-sm text-muted">Загрузка…
 * </p>`, which is what "the state management is not unified" looked like from
 * the reader's side: a spinner while the route resolved, then bare grey text
 * while its four cards filled in, then nothing at all in the two places that
 * had been forgotten. One shape, one delay, one wording.
 *
 * ⚠️ IT DELIBERATELY DOES NOT APPEAR FOR A FAST LOAD, for the same reason
 * `PageLoader` does not: `loader-delayed` holds it at zero opacity for 260ms,
 * so a card whose request resolves in 80ms — which is most of them, the API is
 * on the same origin — shows nothing at all rather than a spinner that flashes
 * and is replaced.
 *
 * ⚠️ AND IT IS NOT A LIVE REGION, unlike `PageLoader`, which is the one
 * difference between them. Посещаемость renders up to four of these at once;
 * four `role="status"` elements appearing together is four announcements
 * interrupting each other to say the same word. The text is in the DOM and is
 * read when the reader reaches it, which is the right behaviour for a
 * placeholder standing where content will be — the ROUTE-level wait is the one
 * worth interrupting for, and that one still announces.
 *
 * ⚠️ WHICH IS WHY THE SPINNER IS WRAPPED. HeroUI's `Spinner` root is itself a
 * `role="status"` with `aria-label="Loading"`, so rendering one bare would put
 * the live region back — in English — by the back door, and the paragraph above
 * would be describing markup this file does not produce.
 */
export function InlineLoader({ label = 'Загрузка…' }: { label?: string }) {
  return (
    <p className="loader-delayed flex items-center gap-2 text-sm text-muted">
      <span aria-hidden="true" className="flex">
        <Spinner size="sm" color="current" />
      </span>
      {label}
    </p>
  );
}
